import React, { useEffect, useState } from 'react';
import UserField from './UserField';


const AddUser = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A New User</h1>
            <UserField></UserField>
        </div>
    );
};

export default AddUser;